export default __webpack_public_path__ + "static/media/gdi_ico_companies.ea59f9ab.svg";